/*
 * Yadid Advisory shared document tokens.
 *
 * Single source of truth for the values that make an artefact "read as"
 * a Yadid Advisory document across every export surface (Meeting Brief
 * PDF, Executive Reflection PDF, Convening Snapshot PDF, Copy-as-Word,
 * printable Word fallback).
 *
 * If a surface diverges from these tokens it should either:
 *   (a) advertise the deviation explicitly (e.g. an invoice retaining
 *       its billing-specific layout), or
 *   (b) be treated as a bug and reunified.
 *
 * Palette — partner-locked Feb 2026: navy = #0F1E3D, brass = #B08048.
 * The old `_EMAIL` aliases are retained as no-op re-exports so any
 * pre-lock import keeps resolving; new code should reach for the
 * canonical names.
 */

// Canonical Yadid document palette — used by every export surface
// (Meeting Brief PDF, Executive Reflection PDF, transactional emails,
// Convening Snapshot PDF, Invoice PDF).
export const YADID_NAVY = "#0F1E3D";
export const YADID_BRASS = "#B08048";
export const YADID_INK = "#1B1E28";           // body text
export const YADID_MUTED = "#7A7F8C";         // page counter, subordinate metadata
export const YADID_META_LABEL = "#8A6A32";    // eyebrow label ochre
export const YADID_META_MUTED_INK = "#4A4F5C";
export const YADID_PAPER = "#ffffff";
export const YADID_IVORY = "#F4F1EA";         // email background

// Legacy aliases — kept so unmigrated imports keep resolving.
export const YADID_NAVY_EMAIL = YADID_NAVY;
export const YADID_BRASS_EMAIL = YADID_BRASS;

// Print / PDF geometry (all in millimetres)
export const YADID_PAGE_FORMAT = "letter";
export const YADID_PDF_MARGIN_MM = [22, 15, 22, 15]; // [top, right, bottom, left]
export const YADID_DOC_INSET_MM = 25;                 // running header/footer + memo body content column
export const YADID_BRASS_STROKE_MM = 0.15;
export const YADID_RUNNING_HEADER_TOP_MM = 12;
export const YADID_RUNNING_HEADER_RULE_MM = 14;
export const YADID_RUNNING_FOOTER_RULE_MM = 14; // distance from page bottom
export const YADID_RUNNING_FOOTER_TEXT_MM = 9;  // distance from page bottom

// Copy for header/footer strings
export const YADID_FIRM_WORDMARK = "YADID ADVISORY";
export const YADID_CONFIDENTIAL_LABEL = "PRIVILEGED & CONFIDENTIAL";
export const YADID_COPYRIGHT_FN = (year) => `\u00A9 ${year} YADID ADVISORY`;

// Typography stacks
export const YADID_FONT_SERIF = "Georgia, 'Times New Roman', serif";
export const YADID_FONT_SANS = "'Helvetica Neue', Arial, sans-serif";
export const YADID_FONT_MONO = "'SF Mono', 'Courier New', monospace";

// Reference-content width used by html2canvas to keep PDF scaling
// consistent across surfaces (matches memo body window).
export const YADID_PDF_WINDOW_WIDTH = 720;
